import { render, staticRenderFns } from "./NuevaClave.vue?vue&type=template&id=2c946684&lang=pug"
import script from "./NuevaClave.vue?vue&type=script&lang=js"
export * from "./NuevaClave.vue?vue&type=script&lang=js"
import style0 from "./NuevaClave.vue?vue&type=style&index=0&id=2c946684&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports